module.exports = __webpack_public_path__ + "media/components/theme/fonts/GT-Pressura-Regular-dbc8ab0f399c2a2aab659364e6247378.ttf";